import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  RELATED_PRODUCTS_AND_FAMILIES_LIST_CONVERTER_TOKEN, RelatedProductsAndFamiliesListConverter
} from './related-products-and-families-list.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        relatedProductsAndFamiliesListFeature: {
          module: () => import('./related-products-and-families-list.module').then((m) => m.RelatedProductsAndFamiliesListModule),
          cmsComponents: ['related_products_and_families_list'],
        },
      }
    }),
    {
      provide: RELATED_PRODUCTS_AND_FAMILIES_LIST_CONVERTER_TOKEN,
      useExisting: RelatedProductsAndFamiliesListConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        related_products_and_families_list: RELATED_PRODUCTS_AND_FAMILIES_LIST_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class RelatedProductsAndFamiliesListFeatureModule {}
